<template>
  <div>
    <div id="AgendarNuevaAudiencias_div" class="w-100 px-5 py-4">
      <div id="TituloAgendarNuevaAudiencas_div">
        <h1 style="margin-bottom: 0px;">AUDIENCIA</h1>
        <h3 style="margin-top: 0px;">Registro de datos de audiencia</h3>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <filtrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="busquedaDeDocumento" :parametrosEstablecidos="parametros_Busqueda" :key="parametros_Busqueda.Key"></filtrosDeBusqueda>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 padding-div-low" id="DocumentosEncontradosNuevaAudiencias_div">
          <div class="area">
            <div id="tableDocumento_div">
              <h4>Documentos encontrados</h4>
              <hr />
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr style="text-align: left;">
                    <th></th>
                    <th></th>
                    <th>Consecutivo</th>
                    <th>Juzgado</th>
                    <th>Materia</th>
                    <th>Tipo de Documento</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="Documentos.length == 0" class="text-center">
                    <td colspan="7">No existe informacion a mostrar</td>
                  </tr>
                  <tr v-for="(item ,index)  in (Documentos)" :key="index">
                    <td v-bind:style="setPadding(item)">
                      <input type="radio" v-bind:value="item.value" v-model="DocumentoIdReferencia" name="documentos_radio" />
                    </td>
                    <td @click="toggle(item, index)">
                      <i v-bind:class="[item.expend ? 'fas fa-minus-circle': (item.DocumentosNoPadreQueGenera && item.DocumentosNoPadreQueGenera.length > 0) ? 'fas fa-plus-circle' : '' ,'']"></i>
                    </td>
                    <td data-th="Consecutivo" v-if="item.level == 0">
                      <span class="q-tree-link q-tree-label">
                        {{item.Consecutivo}}
                      </span>
                    </td>
                    <td data-th="Juzgado" v-if="item.level == 0">{{item.Juzgado.Nombre}}</td>
                    <td data-th="Materia" v-if="item.level == 0">{{item.Materia.Nombre}}</td>
                    <td data-th="TipoDocumento">{{item.TipoDocumento.Nombre}}</td>
                    <td data-th="Detalles" v-if="item.level > 0" colspan="3">{{item.Detalles}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <div id="tableRelacionesDocumento_div">
              <h4>Relaciones</h4>
              <hr />
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th></th>
                    <th>Víctima</th>
                    <th>Imputado</th>
                    <th>Delito</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="RealacionesDocumentoPadre.length == 0" class="text-center">
                    <td colspan="4">No existe informacion a mostrar</td>
                  </tr>
                  <tr v-else v-for="relacion in RealacionesDocumentoPadre">
                    <td><input type="checkbox" v-model="RelacionesDocumento" v-bind:value="relacion.RelacionId" /></td>
                    <td>{{relacion.Victima}}</td>
                    <td>{{relacion.Imputado}}</td>
                    <td>{{relacion.Delito}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div id="tableJuecesDocumento_div">
              <h4>Jueces</h4>
              <hr />
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th></th>
                    <th>Nombre</th>
                    <th>Tipo</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="RealacionesDocumentoPadre.length == 0" class="text-center">
                    <td colspan="3">No existe informacion a mostrar</td>
                  </tr>
                  <tr v-else v-for="juez in JuecesDocumentoPadre">
                    <td><input type="checkbox" v-model="JuecesDocumento" v-bind:value="juez.Juez.IdUsuario" /></td>
                    <td>{{juez.Nombre}}</td>
                    <td>{{juez.TipoJuez.Nombre}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" id="DatosNuevaAudiencias_div">
          <div class="area">
            <h2>Datos de la audiencia</h2>
            <hr />
            <div id="Fecha_div" class="form-group">
              <label for="Fecha">Fecha</label>
              <input id="Fecha" v-model="FechaAudiencia" type="date" class="form-control" />
            </div>
            <div id="Hora_div" class="form-group">
              <label for="Hora">Hora</label>
              <input id="Hora" v-model="Hora" type="text" class="form-control" placeholder="00:00" v-mask="'##:##'" />
            </div>
            <!--<div id="Test_div">
              <label for="Test">¿Es test?</label>
              <SiNo :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :valorDefinido="this.ConTest"></SiNo>
            </div>-->
            <div id="TipoAudiencia_div" class="form-group">
              <label for="TipoAudiencia">Tipo de audiencia</label>
              <C024TipoAudiencia v-on:valorParaElPadre="cambioTipoDeAudiencia" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'audiencia_TipoDeAudiencia'" :valorDefinido="Audiencia.TipoAudiencia != undefined && Audiencia.TipoAudiencia != null ? Audiencia.TipoAudiencia.TipoAudienciaId : -1" :parametros="parametros_TipoAudiencia" :key="Audiencia.TipoAudiencia != undefined && Audiencia.TipoAudiencia != null ? Audiencia.TipoAudiencia.TipoAudienciaId : -1"></C024TipoAudiencia>
            </div>
            <div id="OperadorSala_div" class="form-group">
              <label for="OperadorSala">Operador de sala</label>
              <C001OperadoresDeSala v-on:valorParaElPadre="cambioOperadorDeSala" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'audiencia_OperadorDeSala'" :valorDefinido="Audiencia.Usuario_OperadorDeSala != undefined && Audiencia.Usuario_OperadorDeSala != null ? Audiencia.Usuario_OperadorDeSala.OperadorDeSalaId : -1" :parametros="parametros_OperadorDeSala" :key="Audiencia.Usuario_OperadorDeSala != undefined && Audiencia.Usuario_OperadorDeSala != null ? Audiencia.Usuario_OperadorDeSala.OperadorDeSalaId : -1"></C001OperadoresDeSala>
            </div>
            <div id="TipoEstatus_div" class="form-group">
              <label for="TipoEstatus">Estatus</label>
              <C001TiposEstatusDeLaAudiencia v-on:valorParaElPadre="cambioEstatus" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'audiencia_TipoEstatusDeAudiencia'" :valorDefinido="Audiencia.TipoEstatusDeAudiencia != undefined && Audiencia.TipoEstatusDeAudiencia != null ? Audiencia.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId : 1" :parametros="parametros_TipoEstatusDeLaAudiencia" :key="Audiencia.TipoEstatusDeAudiencia != undefined && Audiencia.TipoEstatusDeAudiencia != null ? Audiencia.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId : -1" :deshabilitado="true"></C001TiposEstatusDeLaAudiencia>
            </div>
            <div id="SalaAudiencia_div" class="form-group">
              <label for="SalaAudiencia">Sala</label>
              <C020Salas v-on:valorParaElPadre="cambioSala" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'audiencia_Sala'" :valorDefinido="Audiencia.Sala != undefined && Audiencia.Sala != null ? Audiencia.Sala.SalaId : -1" :parametros="parametros_Sala" :key="Audiencia.Sala != undefined && Audiencia.Sala != null ? Audiencia.Sala.SalaId : -1"></C020Salas>
            </div>
            <div id="Duracion_div" class="form-group">
              <label for="Duracion">Duración</label>
              <input type="text" class="form-control" id="Duracion" v-model="Duracion" placeholder="00:00" v-mask="'##:##'" />
            </div>
            <div id="RealizarBusquedaAgendaDeAudiencias_div" class="panel-footer text-right">
              <br />
              <button class="btn btn-primary" id="realizarBusquedaAgendaDeAudiencias_btn" v-on:click="guardarAudiencia">Guardar audiencia</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import VueMask from 'v-mask'
  import RouterForseti from '@/router/index'

  Vue.use(VueMask);

  export default {
    components: {
      comun,
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda,
      C020Salas: catalogos.PJ.C020Salas,
      C001Jueces: catalogos.Cuentas.C001Jueces,
      C024TipoAudiencia: catalogos.PJ.C024TipoAudiencia,
      C008Delitos: catalogos.PJ.C008Delitos,
      SiNo: catalogos.Comunes.SiNo,
      C001OperadoresDeSala: catalogos.Cuentas.C001OperadoresDeSala,
      C001TiposEstatusDeLaAudiencia: catalogos.Forseti.C001TiposEstatusDeLaAudiencia,
      RouterForseti,
    },
    data() {
      return {
        enumeraciones,
        Audiencia: {
          AudienciaId: 0
        },
        Consecutivo: "",
        FechaAudiencia: Object,
        Hora: "00:00",
        DocumentoIdReferencia: undefined,
        RelacionesDocumento: [],
        JuecesDocumento: [],
        catalogos: [
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Consecutivo }
        ],
        DocumentoPadre: [],
        RealacionesDocumentoPadre: [],
        JuecesDocumentoPadre: [],
        isExpanded: true,
        rows: [],
        itemId: null,
        parametros_Busqueda: {
          Key: "",
          parametros: {
            PartidoJudicialId: Number,
            AreaId: Number,
            MateriaId: Number,
            TipoDeDocumentoId: Number,
            Consecutivo: String
          }
        },
        parametros_TipoEstatusDeLaAudiencia: {
          TipoEstatusDeAudienciaId: 1
        },
        parametros_Sala: {
          SalaId: -1
        },
        parametros_TipoAudiencia: {
          TipoAudienciaId: -1
        },
        parametros_OperadorDeSala: {
          OperadorDeSalaId: -1
        },
        Duracion: "00:00",
        ConTest: 1
      }
    },
    props: {
      AudienciaId: Number,
      BaseDeDatosProvenienteId: Number,
      FechaAgenda: Object,
      AccionId: Number
    },
    computed: {
      Documentos() {        
        let _this = this;
        var newObj = [];
        _this.recursive(_this.rows, newObj, 0, _this.itemId, _this.isExpanded);
        
        return newObj;
      
      },
    },
    created() {
      if (this.AudienciaId != null && this.AudienciaId != undefined)
        this.busquedaAudiencia();

      let fechaHora = moment(this.FechaAgenda).format('DD/MM/YYYY HH:mm:ss');
      this.FechaAudiencia = moment(this.FechaAgenda).format('YYYY-MM-DD');
      this.Hora = fechaHora.split(' ')[1];
    },
    methods: {
      busquedaAudiencia() {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          AudienciaId: this.AudienciaId,
          BaseDeDatosProvenienteId: this.BaseDeDatosProvenienteId
        }

        axios.post(api.conexion + api.Forseti.sistema.audiencias.agenda.ObtenerAudiencia,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            //CargarDatos de audiencia
            let audiencia = respuesta.data.Audiencia;
            this.Audiencia = audiencia;

            //Cargamos datos de audiencia
            this.Duracion = audiencia.Duracion;
            this.Hora = moment(audiencia.FechaAudiencia).format('HH:mm');
            this.ConTest = audiencia.ConTest != null ? audiencia.ConTest ? 1 : 0 : 1;
            this.Consecutivo = audiencia.Consecutivo;
            this.FechaAudiencia = moment(audiencia.FechaAudiencia).format('YYYY-MM-DD');
            this.parametros_TipoAudiencia.TipoAudienciaId = audiencia.TipoAudiencia != null ? audiencia.TipoAudiencia.TipoAudienciaId : -1;
            this.parametros_OperadorDeSala.OperadorDeSalaId = audiencia.Usuario_OperadorDeSala != null ? audiencia.Usuario_OperadorDeSala.OperadorDeSalaId : -1;
            this.parametros_TipoEstatusDeLaAudiencia.TipoEstatusDeAudienciaId = audiencia.TipoEstatusDeAudiencia != null ? audiencia.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId : -1;
            this.parametros_Sala.SalaId = audiencia.Sala != null ? audiencia.Sala.SalaId : -1;
            //Cargamos datos de documento para busqueda
            this.parametros_Busqueda.parametros.PartidoJudicialId = audiencia.PartidoJudicial.PartidoJudicialId;
            this.parametros_Busqueda.parametros.AreaId = audiencia.Area.AreaId;
            this.parametros_Busqueda.parametros.MateriaId = audiencia.Materia.MateriaId;
            this.parametros_Busqueda.parametros.TipoDeDocumentoId = audiencia.TipoDocumento.TipoDocumentoId;
            this.parametros_Busqueda.parametros.Consecutivo = audiencia.Consecutivo;
            this.parametros_Busqueda.Key = "Busqueda_audiencia" + audiencia.AudienciaId;

            this.$store.dispatch('A_PJ_Catalogo_Establecer009PartidoJudicial', { llave: 'filtroDeBusqueda_PartidoJudicial', valor: audiencia.PartidoJudicial.PartidoJudicialId });
            this.$store.dispatch('A_PJ_Catalogo_Establecer002Materia', { llave: 'filtroDeBusqueda_Materia', valor: audiencia.Materia.MateriaId });
            this.$store.dispatch('A_PJ_Catalogo_Establecer001Area', { llave: 'filtroDeBusqueda_Area', valor: audiencia.Area.AreaId });
            this.$store.dispatch('A_PJ_Catalogo_Establecer004TipoDocumento', { llave: 'filtroDeBusqueda_TipoDocumento', valor: audiencia.TipoDocumento.TipoDocumentoId });
            this.$store.dispatch('A_Comun_Consecutivo', audiencia.Consecutivo);

            //Si los datos ya se cargaron buscamos documento
            this.busquedaDeDocumento();
          }          
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
      validarDatos() {
        if (this.DocumentoPadre.DocumentoId == null || this.DocumentoIdReferencia == undefined) {
          comun.mensajeDeAlerta("Favor de indicar el documento de la audiencia.", null, null);
          return false;
        }
        if (this.RelacionesDocumento == null || this.RelacionesDocumento.length == 0) {
          comun.mensajeDeAlerta("Favor de indicar la relación de la audiencia.", null, null);
          return false;
        }
        if (this.JuecesDocumentoPadre == null || this.JuecesDocumentoPadre.length == 0) {
          comun.mensajeDeAlerta("Favor de indicar juez para la audiencia.", null, null);
          return false;
        }
        if (this.ConTest == null || this.ConTest == undefined) {
          comun.mensajeDeAlerta("Favor de indicar si hay test en la audiencia.", null, null);
          return false;
        }
        if (this.parametros_TipoAudiencia == null || this.parametros_TipoAudiencia.TipoAudienciaId == -1) {
          comun.mensajeDeAlerta("Favor de indicar el tipo de audiencia.", null, null);
          return false;
        }
        if (this.parametros_OperadorDeSala == null || this.parametros_OperadorDeSala.OperadorDeSalaId == -1) {
          comun.mensajeDeAlerta("Favor de indicar el operador de audiencia.", null, null);
          return false;
        }
        if (this.parametros_TipoEstatusDeLaAudiencia == null || this.parametros_TipoEstatusDeLaAudiencia.TipoEstatusDeAudienciaId == -1) {
          comun.mensajeDeAlerta("Favor de indicar el estatus de la audienca.", null, null);
          return false;
        }
        if (this.parametros_Sala == null || this.parametros_Sala.SalaId == -1) {
          comun.mensajeDeAlerta("Favor de indicar la Sala de la audienca.", null, null);
          return false;
        }

        if (parseInt(this.Duracion.split(':')[0]) == 0 && parseInt(this.Duracion.split(':')[1]) == 0) {
          comun.mensajeDeAlerta("Favor de indicar la duración de la audienca.", null, null);
          return false;
        }
        return true;
      },
      crearAudiencia() {
        let _this = this;
  
        this.Audiencia.FechaAudiencia = moment.utc(this.FechaAudiencia.split(' ')[0] + " " + this.Hora);
        this.Audiencia.PartidoJudicial = { PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'] };
        this.Audiencia.Area = { AreaId: this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'] };
        this.Audiencia.Materia = { MateriaId: this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'] };
        this.Audiencia.TipoDocumento = { TipoDocumentoId: this.$store.state.PJ_Catalogos_004TiposDocumento['filtroDeBusqueda_TipoDocumento'] };
        this.Audiencia.Consecutivo = this.Consecutivo == "" ? this.$store.state.Comun_Consecutivo : this.Consecutivo;
        this.Audiencia.Duracion = this.Duracion;
        this.Audiencia.DocumentoIdReferencia = this.DocumentoPadre.DocumentoId;
        this.Audiencia.DocumentoNoPadreIdReferencia = _this.DocumentoIdReferencia.toString().split('.')[0] == 0 ? null : _this.DocumentoIdReferencia.toString().split('.')[1];
        this.Audiencia.AudienciaIdReferencia = this.AccionId == enumeraciones.acciones.Alta ? this.AudienciaId : this.Audiencia.AudienciaIdReferencia;
        this.Audiencia.TipoAudiencia = this.parametros_TipoAudiencia;
        this.Audiencia.BaseDatos = this.AccionId == enumeraciones.acciones.Alta ? { BaseDatosId: this.DocumentoPadre.BaseDeDatosId_025DBPJ } : this.Audiencia.BaseDatos;
        this.Audiencia.Sala = this.parametros_Sala;
        this.Audiencia.TipoEstatusDeAudiencia = this.parametros_TipoEstatusDeLaAudiencia;
        this.Audiencia.ConTest = 1;
        this.Audiencia.Usuario_OperadorDeSala = this.parametros_OperadorDeSala;
        this.Audiencia.RelacionesDeLaAudiencia = this.obtenerRelaciones();        
        this.Audiencia.JuecesEnAudiencia = this.obtenerJueces();
        this.Audiencia.EnServidor = true;
      },
      guardarAudiencia() {
        comun.SeEstaCargandoInformacion(true);
        if (this.validarDatos()) {
          this.crearAudiencia();

          let peticion = {
            Audiencia: this.Audiencia,
            RelacionesDeLaAudiencia: this.obtenerRelaciones()
          }
          
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);                                 

          axios.post(api.conexion + api.Forseti.sistema.audiencias.agenda.GuardarAudiencia,
            peticion,
            headerPeticion            
          ).then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              
            } else {
              comun.mensajeDeAlerta(this.AccionId == enumeraciones.acciones.Alta ? "Audiencia guardada satisfactoriamente." : "Cambios de audiencia guardados satisfactoriamente.", null, null);
              this.limpiarVista();
              comun.SeEstaCargandoInformacion(false);

              RouterForseti.push({
                name: 'Agenda'
              });
            }
            comun.SeEstaCargandoInformacion(false);
          })
            .catch(e => {
              console.log("No Hay Respuesta del Servidor" + e);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);
            });
        } else {
          comun.SeEstaCargandoInformacion(false);
        }
      },
      obtenerRelaciones() {
        let Relaciones = [];
        
        this.RelacionesDocumento.forEach((element) => {
          let relacionAAgregar = this.DocumentoPadre.Relaciones.find(relacion => relacion.RelacionId == element)
          if(relacionAAgregar != undefined)
            Relaciones.push(relacionAAgregar);
        });
        return Relaciones;
      },
      obtenerJueces() {
        let Jueces = []
        this.JuecesDocumento.forEach((element) => { 
          let juezAAgregar = this.JuecesDocumentoPadre.find(juez => juez.Juez.IdUsuario == element)
          if(juezAAgregar != undefined)
            Jueces.push({
              Juez: juezAAgregar.Juez,
              TipoJuez: juezAAgregar.TipoJuez
            })
        });
        return Jueces;
      },
      limpiarVista() {
        this.rows = [];
        this.ConTest = 1;
        this.Duracion = "00:00";
        this.Hora = "00:00";
        this.RealacionesDocumentoPadre = [];
        this.JuecesDocumentoPadre = [];

        this.parametros_Sala.SalaId = -1;
        this.parametros_TipoAudiencia.TipoAudienciaId = -1;
        this.parametros_TipoEstatusDeLaAudiencia.TipoEstatusDeAudienciaId = 1;
        this.parametros_OperadorDeSala.OperadorDeSalaId = -1;

        this.parametros_Busqueda.parametros.Consecutivo = "";
        this.parametros_Busqueda.parametros.PartidoJudicialId = -1;
        this.parametros_Busqueda.parametros.AreaId = -1;
        this.parametros_Busqueda.parametros.MateriaId = -1;
        this.parametros_Busqueda.parametros.TipoDeDocumentoId = -1;
        this.parametros_Busqueda.Key = "Busqueda_audiencia" + -1;

        this.Audiencia = {
          AudienciaId: 0
        }
      },
      ValidaDatosDocumento(datos) {
        if (datos.MateriaId == null || datos.MateriaId == -1) {
          comun.mensajeDeAlerta("Favor de indicar la materia.", null, null);
          return false;
        }
        if (datos.AreaId == null || datos.AreaId == -1) {
          comun.mensajeDeAlerta("Favor de indicar el área.", null, null);
          return false;
        }
        if (datos.TipoDeDocumentoId == null || datos.TipoDeDocumentoId == -1) {
          comun.mensajeDeAlerta("Favor de indicar el tipo de documento.", null, null);
          return false;
        }
        if (datos.Consecutivo == null || datos.Consecutivo == undefined || datos.Consecutivo == "") {
          comun.mensajeDeAlerta("Favor de indicar el consecutivo.", null, null);
          return false;
        }
        return true;
      },
      busquedaDeDocumento() { 
        let _this = this
        this.rows = [];
        this.RealacionesDocumentoPadre = [];
        this.JuecesDocumentoPadre = [];

        let peticion = {
          MateriaId: this.$store.state.PJ_Catalogos_002Materias["filtroDeBusqueda_Materia"],
          AreaId: this.$store.state.PJ_Catalogos_001Areas["filtroDeBusqueda_Area"],
          TipoDeDocumentoId: this.$store.state.PJ_Catalogos_004TiposDocumento["filtroDeBusqueda_TipoDocumento"],
          Consecutivo: this.$store.state.Comun_Consecutivo,
          EsPrueba: this.enumeraciones.EsPrueba,
        }

        if (this.ValidaDatosDocumento(peticion)) {
          comun.SeEstaCargandoInformacion(true);
          axios.post(api.conexion + api.Forseti.sistema.audiencias.agenda.ObtenerDocumento,
            peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => { 
            comun.SeEstaCargandoInformacion(true);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              if (respuesta.data.DocumentoPadre.DocumentoId <= 0) {
                comun.mensajeDeAlerta("No se encuentra documento, favor de verificar los datos.", null, null);

              } else {
                this.DocumentoPadre = respuesta.data.DocumentoPadre;
                //console.log(this.DocumentoPadre);                

                //Crear objetos para mostrar árbol
                this.rows = [this.DocumentoPadre];

                //Cargar Relaciones del documento
                _this.cargaRelaciones(this.DocumentoPadre.Relaciones);
                _this.cargaJueces(this.DocumentoPadre.Jueces);

              }
            }
            
          })
            .then(response => {
              this.seleccionarDocumentoDeReferecia();
              this.seleccionarRelacion();
              this.seleccionarJueces();
              comun.SeEstaCargandoInformacion(false);
            })
            .catch(e => {
              console.log("No Hay Respuesta del Servidor" + e);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
            
        }
      },
      seleccionarDocumentoDeReferecia() {        
        if (this.Audiencia.DocumentoIdReferencia != undefined) {
          let value = this.Audiencia.DocumentoNoPadreIdReferencia == null ? "0." + this.Audiencia.DocumentoIdReferencia : this.Audiencia.DocumentoIdReferencia + "." + this.Audiencia.DocumentoNoPadreIdReferencia;
          this.DocumentoIdReferencia = value;
        }        
      },
      cargaRelaciones(relaciones) {        
        let _this = this

        relaciones.forEach(function (element) {
          _this.RealacionesDocumentoPadre.push({
            RelacionId: element.RelacionId,
            Victima: _this.formatoNombrePersonalidad(element.Victima.DatosGenerales),
            Imputado: _this.formatoNombrePersonalidad(element.Imputado.DatosGenerales),
            Delito: element.Delito.Nombre
          });
        });        
      },
      seleccionarRelacion() {       
        let _this = this;
        if (this.Audiencia.AudienciaId > 0) {
          this.Audiencia.RelacionesDeLaAudiencia.forEach(function (relacion) {
            _this.RelacionesDocumento.push(relacion.RelacionId);
          });
        }       
      },
      cargaJueces(jueces) {        
        let _this = this

        jueces.forEach(function (element) {
          _this.JuecesDocumentoPadre.push({
            JuezId: element.JuezEnAudienciaId,
            Nombre: _this.formatoNombrePersonalidad({ Fisica: element.Juez, TipoPersona: { TipoPersonaId: 2 } }),
            Juez: element.Juez,
            TipoJuez: element.TipoJuez,
          });
        });        
      },
      seleccionarJueces() {
        let _this = this;
        if (this.Audiencia.AudienciaId > 0) {
          this.Audiencia.JuecesEnAudiencia.forEach(function (juez) {
            _this.JuecesDocumento.push(juez.Juez.IdUsuario);
          });
        }
      },
      cambioTipoDeAudiencia(datos) {
        this.parametros_TipoAudiencia.TipoAudienciaId = parseInt(datos.target.value);
      },
      cambioOperadorDeSala(datos) {
        this.parametros_OperadorDeSala.OperadorDeSalaId = parseInt(datos.target.value);
      },
      cambioEstatus(datos) {
        this.parametros_TipoEstatusDeLaAudiencia.TipoEstatusDeAudienciaId = parseInt(datos.target.value);
      },
      cambioSala(datos) {
        this.parametros_Sala.SalaId = parseInt(datos.target.value);
      },
      formatoNombrePersonalidad(value) {
        var Nombre = "";
        if (value != null && value != undefined) {
          switch (parseInt(value.TipoPersona.TipoPersonaId)) {
            case 1: //Autoridad
              Nombre = value.Autoridad.Institucion;
              break;
            case 2: //Física
              Nombre = (value.Fisica.Nombres == null || value.Fisica.Nombres == "" ? value.Fisica.Nombre : value.Fisica.Nombres) +
                (value.Fisica.ApellidoPaterno != "" && value.Fisica.ApellidoPaterno != null ? " " + value.Fisica.ApellidoPaterno : "") +
                (value.Fisica.ApellidoMaterno != "" && value.Fisica.ApellidoMaterno != null ? " " + value.Fisica.ApellidoMaterno : "");
              break;
            case 3: //Moral
              Nombre = value.Moral.Nombre;
              break;
            default:
              Nombre = "Sin Victima";
              break;
          }
        } else {
          if (value.ResulteResponsable)
            Nombre = "Sin Victima";
        }
        return Nombre;
      },
      recursive(obj, newObj, level, itemId, isExpend) {        
        let _this = this;

        obj.forEach(function (documento) {

          if (documento.DocumentosNoPadreQueGenera && documento.DocumentosNoPadreQueGenera.length != 0) {
            documento.level = level;
            documento.value = documento.DocumentoPadreId == null ? 0 + "." + documento.DocumentoId : documento.DocumentoPadreId + "." + documento.DocumentoId;
            newObj.push(documento);
            if (documento.DocumentoId == itemId) {
              documento.expend = isExpend;
            }
            if (documento.expend == true) {
              _this.recursive(documento.DocumentosNoPadreQueGenera, newObj, documento.level + 1, itemId, isExpend);
            }
          } else {
            documento.level = level;
            documento.value = documento.DocumentoPadreId == null ? 0 + "." + documento.DocumentoId : documento.DocumentoPadreId + "." + documento.DocumentoId;
            newObj.push(documento);
            return false;
          }
        });        
      },
      toggle(item, index) {
        let _this = this;
        _this.itemId = item.DocumentoId;
        //mostrar documentos hijos al dar click + (more)
        if (
          item.expend == undefined &&
          item.DocumentosNoPadreQueGenera != undefined
        ) {
          if (item.DocumentosNoPadreQueGenera.length != 0) {
            _this.recursive(item.DocumentosNoPadreQueGenera, [], item.level + 1, item.DocumentoId, true);
          }
        }

        if (item.expend == true && item.DocumentosNoPadreQueGenera != undefined) {
          item.DocumentosNoPadreQueGenera.forEach(function (documento) {
            documento.expend = undefined;
          });

          _this.$set(item, "expend", undefined);
          _this.itemId = null;
        }
      },
      setPadding(item) {
        return `padding-left: ${(item.level + 1) * 20}px;`;
      }
    },

  }

</script>
<style>
  .padding-div-low {
    padding-top: 40px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/AgendaDeAudiencias/AgendarNuevaAudiencia.vue